import {
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import showToast from "../../../components/Hot-Toast/showToast";
import { useTMutation } from "../../../utils/useTMutation";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { QualificationSchema } from "../../../hooks/validationSchema";

export default function ClinicianQualification({ data }) {
  console.log("data", data?.ID);
  const [openPopup, setOpenPopup] = useState("");
  const { controlBy, controlAction } = useSelector(state => state.user);
  const [qualificationDetails, setQualificationDetails] = useState(data?.qualification || []);
  console.log("qualificationDetails", qualificationDetails);
  const [qualification, setQualification] = useState("");
  const [selectedlanguage, setSelectedLanguage] = useState([]);
  const [languageError, setLanguageError] = useState(false);
  const [values, setValues] = React.useState({
    DEGREE_NAME: "",
    INSTITUTE_NAME: "",
    FROM_YEAR: '',
    TO_YEAR: "",
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: zodResolver(QualificationSchema),
  });

  // const [errors, setErrors] = useState({
  //   DEGREE_NAME: false,
  //   INSTITUTE_NAME: false,
  //   FROM_YEAR: false,
  //   TO_YEAR: false,
  //   LANGUAGE: false,
  // });

  const medicalDegrees = [
    { value: "MBBS", label: "MBBS" },
    { value: "MD", label: "MD" },
    { value: "DO", label: "DO" },
    { value: "PhD", label: "PhD" },
  ];

  const mutation = useTMutation("/profile", "patch", (data) => data);

  const deleteMutation = useTMutation("/deleteProfile", "post", (data) => {
    if (data.STATUS) {
      showToast('success', data.MESSAGE);
      return data;
    } else {
      showToast("error", data.MESSAGE, 3000);
    }
  });

  useEffect(() => {
    if (data?.LANGUAGES) {
      setSelectedLanguage(data?.LANGUAGES);
    }
    if (data?.qualification) {
      setQualificationDetails(data?.qualification);
    }
  }, [data?.LANGUAGES, data?.qualification]);


  useEffect(() => {
    console.log("selectedlanguage updated:", selectedlanguage);
  }, [selectedlanguage]);

  const handleChange = (name) => (event) => {
    if (name === "language") {
      setLanguageError(false);
      setQualification(event?.target?.value);
    }
  };
  const handleQualificationChange = (e) => {
    setValue('qualification', e);
  };

  // const validateQualification = () => {
  //   const { DEGREE_NAME, INSTITUTE_NAME, FROM_YEAR, TO_YEAR } = values;
  //   let isValid = true;
  //   let newErrors = {};

  //   if (!DEGREE_NAME) {
  //     isValid = false;
  //     newErrors.DEGREE_NAME = true;
  //   }

  //   if (!INSTITUTE_NAME) {
  //     isValid = false;
  //     newErrors.INSTITUTE_NAME = true;
  //   }
  //   if (!FROM_YEAR) {
  //     isValid = false;
  //     newErrors.FROM_YEAR = true;
  //   }
  //   if (!TO_YEAR) {
  //     isValid = false;
  //     newErrors.TO_YEAR = true;
  //   }

  //   return isValid;
  // };

  const addLanguage = async () => {
    const lang = qualification.trim();
    if (!lang) {
      console.log("Language cannot be empty");
      setLanguageError('Language cannot be empty');
      return;
    }

    if (selectedlanguage.includes(lang)) {
      setLanguageError('Language already exists');
      return;
    }
    const updatedLanguages = [...selectedlanguage, lang];
    setSelectedLanguage(updatedLanguages);
    setQualification("");
    // setErrors({ ...errors, LANGUAGE: false });
    try {
      const response = await mutation.mutateAsync({
        LANGUAGES: updatedLanguages,
        USER_ID: data?.ID,
      });

      if (response?.STATUS) {
        showToast('success', 'Languages added successfully');
        // setOpenPopup(false);
      }
    } catch (error) {
      showToast('error', 'Failed to save languages');
    }
  };

  const saveLanguages = async () => {
    console.log("selectedlnguage", selectedlanguage);
    const lang = qualification.trim();

    if (qualification == '' && selectedlanguage.length == 0) {
      setLanguageError("Please add at least one language");
      return;
    }

    let updatedLanguages;

    if (!lang) {
      updatedLanguages = [...selectedlanguage];
    } else {
      if (selectedlanguage.includes(lang)) {
        setLanguageError("Language already exists");
        return;
      }
      updatedLanguages = [...selectedlanguage, lang];
    }

    console.log("kkkikio", updatedLanguages);

    setSelectedLanguage(updatedLanguages);
    setQualification("");
    setLanguageError("");

    try {
      const response = await mutation.mutateAsync({
        LANGUAGES: updatedLanguages,
        USER_ID: data?.ID,
      });

      if (response?.STATUS) {
        showToast('success', 'Languages updated successfully');
        setOpenPopup(false);
      }
    } catch (error) {
      showToast('error', 'Failed to save languages');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addLanguage();
    }
  };

  async function addQualificationDetail(values) {
    // return console.log("data", data);

    // if (!validateQualification()) return;
    const payload = { QUALIFICATIONS: values, USER_ID: data?.ID };
    console.log("payload", payload);
    const response = await mutation.mutateAsync(payload);
    if (response.STATUS) {
      setQualificationDetails([...qualificationDetails, response.OUTPUT]);
      setOpenPopup(false);
    }
  }

  // function handleDateChange(name, date) {
  //   let set = date.toDate();
  //   let check = String(set).split(" ");
  //   if (name === "TO_YEAR") {
  //     setValues({ ...values, TO_YEAR: check[1] + "/" + check[3] });
  //   } else if (name === "FROM_YEAR") {
  //     setValues({ ...values, FROM_YEAR: check[1] + "/" + check[3] });
  //   }
  // }

  const handleDelete = async (selectedItem, type) => {
    console.log("selectedItem", selectedItem);
    const response = await deleteMutation.mutateAsync({
      ID: selectedItem,
      DeleteType: type,
      USER_ID: data?.ID
    });
    if (response.STATUS) {
      let arr = qualificationDetails?.filter((val) => val?.qualificationID !== selectedItem);
      setQualificationDetails(arr);
    }
  }

  const handleChipDelete = async (index) => {
    const updatedLanguages = selectedlanguage.filter((_, i) => i !== index);
    setSelectedLanguage(updatedLanguages);
    const response = await mutation.mutateAsync({
      LANGUAGES: updatedLanguages,
      USER_ID: data?.ID,
    });

  };

  const closePopup = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setOpenPopup(false);
    setQualification("");
  };

  function checkPopup() {
    setValues({
      DEGREE_NAME: "",
      INSTITUTE_NAME: "",
      FROM_YEAR: "",
      TO_YEAR: ""
    });
    closePopup();
  }

  return (
    <>
      <Card sx={{ padding: "20px", marginTop: 2 }}>
        <Grid container display="flex" justifyContent={"space-between"}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h5" className="about_text_black" >Qualification & Language</Typography>

            {(controlAction !== "view" && controlBy !== "facility") &&
              <Grid mb={2}>
                <span
                  className="addText"
                  style={{ textDecoration: "underline", cursor: "pointer", color: "#008000" }}
                  onClick={() => { setOpenPopup("clinicianQualification"); reset() }}>
                  + Add Qualification
                </span>
                <br />
                <span
                  className="addText"
                  style={{ textDecoration: "underline", cursor: "pointer", color: "#008000" }}
                  onClick={() => { setOpenPopup("clinicianLanguage"); setLanguageError(false) }}>
                  + Add Language
                </span>
              </Grid>
            }
          </Grid>
        </Grid>

        <Grid container spacing={2}>
        {qualificationDetails && qualificationDetails.length > 0 ? (
  qualificationDetails.map((data, key) => (
    <Grid item xs={12} lg={3} mt={1.1} key={key}>
      <Card className="license" style={{ boxShadow: "2px 2px 2px 2px lightgrey" }}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid px={2}>
            <Grid mt={0.5} pt={1}>
              <Typography variant="h5">{data?.DEGREE_NAME}</Typography>
            </Grid>
            <Grid mt={0.5} pt={1}>
              <Typography
                variant="body3"
                sx={{ color: "#777e89", fontWeight: 500 }}>
                {data?.INSTITUTE_NAME}
              </Typography>
            </Grid>
            <Grid mt={0.5} pt={1}>
              <Typography variant="body3" sx={{ fontWeight: 700 }}>
                {dayjs(data.FROM_YEAR).format('MMM YYYY')} - {dayjs(data.TO_YEAR).format('MMM YYYY')}
              </Typography>
            </Grid>
          </Grid>
          {(controlBy !== "facility") &&
            <Grid mt={-0.2}>
              <span onClick={() => handleDelete(data?.qualificationID, 'clinicianQualification')}>
                <CloseIcon sx={{ cursor: "pointer" }} />
              </span>
            </Grid>
          }
        </Box>
      </Card>
    </Grid>
  ))
) : (
  <Grid item xs={12}>
    <Typography variant="body2" sx={{ textAlign: "left", color: "gray" }}>
      No qualification found
    </Typography>
  </Grid>
)}

        </Grid>
        <Grid container>
          {selectedlanguage?.length > 0 && <Grid item lg={12}>
            <Typography variant="h5" className="about-text-qualification">Language <span style={{ fontSize: "12px" }}> (Click language to edit)</span></Typography>
            <Stack direction={"row"} flexWrap="wrap">
              {selectedlanguage && selectedlanguage?.map((chip, key) => (
                <Chip
                  key={key}
                  sx={{
                    background: "#CFEEE2",
                    borderRadius: "8px",
                    marginRight: 1,
                    marginTop: 1,
                  }}
                  label={chip}
                  onClick={controlBy === "facility" ? undefined : () => { setOpenPopup("clinicianLanguage"); setLanguageError(false) }}
                />
              ))}
            </Stack>
          </Grid>}
        </Grid>
      </Card>
      <Dialog
        open={openPopup}
        onClose={closePopup}
        fullWidth
        maxWidth="xs">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={2}
          px={2}>
          <Typography
            gutterBottom
            ml={1}
            sx={{
              fontWeight: 600,
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
            }}>
            {openPopup === "clinicianQualification"
              ? "Add Qualification"
              : "Add Language"}
          </Typography>
          <CloseIcon
            sx={{ cursor: "pointer", color: "#000000", opacity: "87%" }}
            onClick={() => checkPopup()}
          />
        </Box>

        {openPopup === "clinicianQualification" && (
          <form onSubmit={handleSubmit(addQualificationDetail)}>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item lg={12} mt={-1}>
                  <FormControl fullWidth error={!!errors.DEGREE_NAME}>
                    <InputLabel id="degree-label">General Qualification</InputLabel>
                    <Controller
                      name="DEGREE_NAME"
                      control={control}
                      rules={{ required: "Degree name is required" }}
                      render={({ field }) => (
                        <>
                          <Select
                            labelId="degree-label"
                            id="degree-select"
                            size="small"
                            variant="outlined"
                            label="General Qualification"
                            {...field}
                            onChange={(e) => {
                              field.onChange(e);
                              handleQualificationChange(e.target.value);
                            }}
                            error={!!errors?.DEGREE_NAME}
                            sx={{
                              '& .MuiOutlinedInput-input': {
                                padding: 1.814,
                              },
                            }}
                          >
                            {medicalDegrees?.map((degree) => (
                              <MenuItem key={degree?.value} value={degree?.value}>
                                {degree?.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors?.DEGREE_NAME && (
                            <FormHelperText error>
                              {errors?.DEGREE_NAME.message}
                            </FormHelperText>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item lg={12}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      variant="outlined"
                      fullWidth
                      label="Institute"
                      inputProps={{ maxLength: 50 }}
                      {...register('INSTITUTE_NAME', { required: "Institute name is required" })}
                      error={!!errors.INSTITUTE_NAME}
                      helperText={errors.INSTITUTE_NAME?.message}
                      sx={{
                        '& .MuiOutlinedInput-input': {
                          padding: 1.814
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Grid item xs={6}>
                    <Controller
                      name="FROM_YEAR"
                      control={control}
                      rules={{ required: "From date is required" }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            label="From Date"
                            views={['year', 'month']}
                            value={field.value ? dayjs(field.value) : null}

                            onChange={(date) => {
                              field.onChange(date?.toDate() || null);
                              if (watch('TO_YEAR') && date && dayjs(watch('TO_YEAR')).isBefore(date)) {
                                setValue('TO_YEAR', null);
                              }
                            }}
                            maxDate={dayjs()}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!errors.FROM_YEAR}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: 1.814
                              }
                            }}
                          />
                          {errors.FROM_YEAR && (
                            <FormHelperText error>{errors.FROM_YEAR.message}</FormHelperText>
                          )}
                        </>
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="TO_YEAR"
                      control={control}
                      rules={{
                        required: "To date is required",
                        validate: (value) =>
                          !watch('FROM_YEAR') ||
                          !value ||
                          dayjs(value).isAfter(dayjs(watch('FROM_YEAR'))) ||
                          "To date must be after From date"
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            label="To Date"
                            views={['year', 'month']}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(date) => {
                              field.onChange(date?.toDate() || null);
                            }}
                            minDate={watch('FROM_YEAR') ? dayjs(watch('FROM_YEAR')).add(1, 'month') : null}
                            maxDate={dayjs()}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                error={!!errors.TO_YEAR}
                              />
                            )}
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: 1.814
                              }
                            }}
                          />
                          {errors.TO_YEAR && (
                            <FormHelperText error>{errors.TO_YEAR.message}</FormHelperText>
                          )}
                        </>
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: "8px 24px" }}>
              <Button
                variant="contained"
                className='custombutton'
                type='submit'
              >
                Done
              </Button>
            </DialogActions>
          </form>
        )}

        {openPopup === "clinicianLanguage" && (
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item lg={12} mt={-1}>
                <FormControl fullWidth error={errors.LANGUAGE}>
                  <TextField
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={qualification}
                    placeholder="Add language and press Enter"
                    onChange={handleChange("language")}
                    onKeyPress={handleKeyPress}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        padding: 1.814
                      },
                    }}
                  />
                  {languageError && (
                    <FormHelperText error>{languageError}</FormHelperText>
                  )}
                </FormControl>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {selectedlanguage.map((lang, index) => (
                    <Chip
                      key={index}
                      label={lang}
                      style={{ marginTop: "8px" }}
                      onDelete={() => handleChipDelete(index)}
                      sx={{
                        background: "#CFEEE2",
                        borderRadius: "8px",
                        marginBottom: 1,
                      }}
                    />
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </DialogContent>
        )}

        <DialogActions sx={{ padding: "8px 24px" }}>
          {openPopup === "clinicianLanguage" && (
            <Button
              variant="contained"
              className='custombutton'
              onClick={saveLanguages}
            >
              Done
            </Button>
          )}
        </DialogActions>
      </Dialog>

    </>
  );
}